export const colleaguesContext = {
    title: "Filtre",
    search: {
      placeholder: "Filtrez les praticiens",
			title: "Filtrez la liste de praticiens affichée ci-contre"
    }
}